import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api, { errMsg } from "../api";

export default function SetPassword() {
  const { token } = useParams();
  const [loading, setLoading] = useState(true);
  const [linkError, setLinkError] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get(`/auth/invitation/${token}`)
      .then((r) => { setEmail(r.data.email); setLoading(false); })
      .catch((e) => { setLinkError(errMsg(e)); setLoading(false); });
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password.length < 10) { setError("Le mot de passe doit contenir au moins 10 caractères."); return; }
    if (password !== confirm) { setError("Les deux mots de passe ne correspondent pas."); return; }
    setBusy(true);
    try {
      await api.post("/auth/set-password", { token, password, password_confirm: confirm });
      setDone(true);
    } catch (err) { setError(errMsg(err)); }
    finally { setBusy(false); }
  };

  const inputCls = "mt-1 w-full rounded-lg border border-slate-300 px-3 py-2.5 text-sm focus:ring-2 focus:ring-slate-900 focus:outline-none";

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <div className="text-2xl font-semibold text-slate-900 tracking-tight">Saphir Immo SA</div>
          <div className="text-slate-500 text-sm mt-1">Conciergerie · Blanchisserie · Nettoyage</div>
        </div>
        <div className="bg-white rounded-lg border border-slate-200 p-8 space-y-5" data-testid="set-password-page">
          <h1 className="text-base font-semibold text-slate-900">Définir votre mot de passe</h1>
          {loading && <p className="text-sm text-slate-500" data-testid="set-password-loading">Vérification du lien…</p>}
          {!loading && linkError && (
            <>
              <div className="bg-red-50 border border-red-200 text-red-700 text-sm rounded-lg px-3 py-2" data-testid="set-password-link-error">{linkError}</div>
              <Link to="/login" data-testid="set-password-back-link" className="block text-center text-sm text-slate-600 hover:text-slate-900 font-medium">Retour à la connexion</Link>
            </>
          )}
          {!loading && !linkError && !done && (
            <form onSubmit={submit} className="space-y-5" data-testid="set-password-form">
              <p className="text-sm text-slate-600">Compte : <span className="font-medium text-slate-900" data-testid="set-password-email">{email}</span></p>
              {error && <div className="bg-red-50 border border-red-200 text-red-700 text-sm rounded-lg px-3 py-2" data-testid="set-password-error">{error}</div>}
              <div>
                <label className="text-xs font-semibold text-slate-500 uppercase tracking-wider">Mot de passe (10 caractères min.)</label>
                <input data-testid="set-password-input" type="password" required minLength={10} value={password}
                  onChange={(e) => setPassword(e.target.value)} className={inputCls} />
              </div>
              <div>
                <label className="text-xs font-semibold text-slate-500 uppercase tracking-wider">Confirmer le mot de passe</label>
                <input data-testid="set-password-confirm" type="password" required minLength={10} value={confirm}
                  onChange={(e) => setConfirm(e.target.value)} className={inputCls} />
              </div>
              <button data-testid="set-password-submit" type="submit" disabled={busy}
                className="w-full bg-slate-900 text-white rounded-lg py-2.5 text-sm font-semibold hover:bg-slate-800 transition-colors disabled:opacity-50">
                {busy ? "Enregistrement…" : "Enregistrer le mot de passe"}
              </button>
            </form>
          )}
          {done && (
            <div className="space-y-4" data-testid="set-password-success">
              <p className="text-sm text-slate-700">Votre mot de passe est enregistré. Vous pouvez maintenant vous connecter.</p>
              <Link to="/login" data-testid="set-password-login-link"
                className="block w-full text-center bg-slate-900 text-white rounded-lg py-2.5 text-sm font-semibold hover:bg-slate-800 transition-colors">
                Aller à la connexion
              </Link>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
